export default __webpack_public_path__ + "static/media/egg-step3-video.3dd28d67.mp4";